export const addOpacity = (hexColor, opacityPercentage) => {
    const opacityValue = Math.round((opacityPercentage / 100) * 255);
    const opacityHex = opacityValue.toString(16).padStart(2, '0');
    return `${hexColor}${opacityHex}`;
};
